import React, {Suspense, lazy, useMemo} from 'react'
import {Route, Switch, Redirect} from 'react-router-dom'
import {useAppSelector} from 'store/redux'
import {shallowEqual} from 'react-redux'
import {selectAccountAccess, selectStations, selectUserRole} from 'store/selectors'

import * as routes from 'shared/routes'
import {PrivateRoute, getUserRoles, hasPermission} from 'containers/RoleModel'
import Loader from 'pages/Loader'
import {routeList} from './routeConfig'

const PageNotFound = lazy(() => import('pages/NotFound'))
const NoAccess = lazy(() => import('pages/NoAccess'))
const InternalServerError = lazy(() => import('pages/InternalServerError'))

const Routes = () => {
  const {spp, wpp} = useAppSelector(selectStations, shallowEqual)
  const {hasAccess, hasServerError, isLoadedPermission} = useAppSelector(
    selectAccountAccess,
    shallowEqual,
  )
  const roleId = useAppSelector(selectUserRole)

  const defaultRoute = useMemo(() => {
    const roles = hasAccess && roleId ? getUserRoles(roleId) : []
    const firstAvailableRoute = routeList.find(
      route => route.permission && hasPermission({permissions: route.permission, roles}),
    )

    return firstAvailableRoute?.path || routes.NO_ACCESS
  }, [hasAccess, roleId])

  const renderErrorPage = () => {
    if (!isLoadedPermission) return null

    if (hasServerError) {
      return (
        <Switch>
          <Route path="*" render={() => <InternalServerError />} />
        </Switch>
      )
    }

    return null
  }

  const errorPage = renderErrorPage()

  return (
    <Suspense fallback={<Loader />}>
      {errorPage || (
        <Switch>
          <Route exact path={routes.NOT_FOUND} render={() => <PageNotFound />} />
          <Route path={routes.NO_ACCESS} render={() => <NoAccess />} />
          {routeList.map(
            route =>
              route.permission && <PrivateRoute key={route.path} plants={{spp, wpp}} {...route} />,
          )}
          <Redirect exact from="/" to={defaultRoute} />
          <Redirect to={routes.NOT_FOUND} />
        </Switch>
      )}
    </Suspense>
  )
}

export default Routes
